import { render, staticRenderFns } from "./addToWishlist.vue?vue&type=template&id=25211814&"
import script from "./addToWishlist.vue?vue&type=script&lang=js&"
export * from "./addToWishlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/__w/one-stop-shop/one-stop-shop/one-stop-shop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25211814')) {
      api.createRecord('25211814', component.options)
    } else {
      api.reload('25211814', component.options)
    }
    module.hot.accept("./addToWishlist.vue?vue&type=template&id=25211814&", function () {
      api.rerender('25211814', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "web/wp-content/themes/global-theme/views/pages/productAside/Heading/addToWishlist.vue"
export default component.exports